var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-elements" },
    [
      _c("div", { staticClass: "va-row" }, [
        _c(
          "div",
          {
            staticClass: "flex md12 xs12",
            staticStyle: { "padding-bottom": "0", backgroundColor: "#FFFFFF" },
          },
          [
            _c(
              "vuestic-widget",
              {
                attrs: {
                  headerText: _vm._f("translate")("forms.inputs.appInfo"),
                  id: "appInfoWrap",
                },
              },
              [
                _c("div", { staticClass: "va-row" }, [
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "360px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md10" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("appName"),
                                  valid: _vm.isFormFieldValid("appName"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.appName,
                                        expression: "appForm.appName",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "appNameInput",
                                      name: "appName",
                                      "data-vv-as": "App Name",
                                      maxlength: "128",
                                      autocomplete: "off",
                                      required: "",
                                    },
                                    domProps: { value: _vm.appForm.appName },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "appName",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "appName" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.appName"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("appName"),
                                          expression: "errors.has('appName')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("appName"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("contactEmail"),
                                  valid: _vm.simpleEmailValid,
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.contactEmail,
                                        expression: "appForm.contactEmail",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|email",
                                        expression: "'required|email'",
                                      },
                                    ],
                                    attrs: {
                                      id: "contactEmail",
                                      name: "contactEmail",
                                      "data-vv-as": "Contact Email",
                                      autocomplete: "off",
                                      maxlength: "100",
                                      required: "",
                                    },
                                    domProps: {
                                      value: _vm.appForm.contactEmail,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "contactEmail",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "contactEmail" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.contactEmail"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("contactEmail"),
                                          expression:
                                            "errors.has('contactEmail')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("contactEmail"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "form-group" }, [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.appForm.website,
                                      expression: "appForm.website",
                                    },
                                  ],
                                  attrs: {
                                    id: "websiteUrl",
                                    name: "website",
                                    "data-vv-as": "Name",
                                    autocomplete: "off",
                                    maxlength: "128",
                                    readonly: true,
                                  },
                                  domProps: { value: _vm.appForm.website },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.appForm,
                                        "website",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "websiteUrl" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.appInfo.website"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                staticStyle: { "margin-bottom": "30px" },
                              },
                              [
                                _c("vuestic-checkbox", {
                                  attrs: {
                                    label: _vm.$t("t.status") + "：",
                                    disabled: "",
                                  },
                                  model: {
                                    value: _vm.checkbox.readonly,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.checkbox, "readonly", $$v)
                                    },
                                    expression: "checkbox.readonly",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                attrs: { id: "selectWrapper" },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    attrs: {
                                      id: "industry",
                                      label: _vm.$t(
                                        "createApp.appInfo.industry"
                                      ),
                                      name: "industry",
                                      readonly: true,
                                      autocomplete: "off",
                                    },
                                    domProps: { value: _vm.queryIndustry },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "industry" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.industry"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md10" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                attrs: {
                                  id: "appNameInput",
                                  name: "appName",
                                  readonly: true,
                                  autocomplete: "off",
                                },
                                domProps: { value: _vm.appForm.appName },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "appName" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.appName"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                attrs: {
                                  id: "contactEmail",
                                  name: "contactEmail",
                                  autocomplete: "off",
                                  readonly: true,
                                },
                                domProps: { value: _vm.appForm.contactEmail },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "contactEmail" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.contactEmail"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "url",
                                    expression: "'url'",
                                  },
                                ],
                                attrs: {
                                  id: "websiteUrl",
                                  name: "website",
                                  readonly: true,
                                  autocomplete: "off",
                                },
                                domProps: { value: _vm.appForm.website },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "website" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.website"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              staticStyle: { "margin-bottom": "30px" },
                            },
                            [
                              _c("vuestic-checkbox", {
                                attrs: {
                                  label: _vm.$t("t.status") + "：",
                                  readonly: true,
                                },
                                model: {
                                  value: _vm.checkbox.readonly,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.checkbox, "readonly", $$v)
                                  },
                                  expression: "checkbox.readonly",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              attrs: { id: "selectWrapper" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  attrs: {
                                    id: "industry",
                                    label: _vm.$t("createApp.appInfo.industry"),
                                    name: "industry",
                                    readonly: true,
                                    autocomplete: "off",
                                  },
                                  domProps: { value: _vm.queryIndustry },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "industry" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.appInfo.industry"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]
                          ),
                        ]),
                      ]),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "360px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md10" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("appNameShort"),
                                  valid: _vm.isFormFieldValid("appNameShort"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.appNameShort,
                                        expression: "appForm.appNameShort",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "appNameShortInput",
                                      name: "appNameShort",
                                      "data-vv-as": "App Name Abbreviation",
                                      maxlength: "12",
                                      autocomplete: "off",
                                      required: "",
                                    },
                                    domProps: {
                                      value: _vm.appForm.appNameShort,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "appNameShort",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "appNameShort" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.appNameShort"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("appNameShort"),
                                          expression:
                                            "errors.has('appNameShort')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("appNameShort"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("managerName"),
                                  valid: _vm.isFormFieldValid("managerName"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.managerName,
                                        expression: "appForm.managerName",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "managerNameInput",
                                      name: "managerName",
                                      "data-vv-as": "Manager Name",
                                      maxlength: "128",
                                      autocomplete: "off",
                                      required: "",
                                    },
                                    domProps: {
                                      value: _vm.appForm.managerName,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "managerName",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "managerName" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.managerName"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("managerName"),
                                          expression:
                                            "errors.has('managerName')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("managerName"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("cellPhone"),
                                  valid: _vm.isFormFieldValid("cellPhone"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.cellPhone,
                                        expression: "appForm.cellPhone",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|verifyCellPhone",
                                        expression:
                                          "'required|verifyCellPhone'",
                                      },
                                    ],
                                    attrs: {
                                      id: "cellPhone",
                                      name: "cellPhone",
                                      "data-vv-as": "Cell Phone",
                                      autocomplete: "off",
                                      maxlength: "20",
                                      required: "",
                                    },
                                    domProps: { value: _vm.appForm.cellPhone },
                                    on: {
                                      input: [
                                        function ($event) {
                                          if ($event.target.composing) return
                                          _vm.$set(
                                            _vm.appForm,
                                            "cellPhone",
                                            $event.target.value
                                          )
                                        },
                                        function ($event) {
                                          _vm.updatePhoneStatus(
                                            !_vm.isOverseaMobileVaild(
                                              _vm.appForm.cellPhone
                                            )
                                          )
                                        },
                                      ],
                                      blur: function ($event) {
                                        _vm.updatePhoneStatus(
                                          !_vm.isOverseaMobileVaild(
                                            _vm.appForm.cellPhone
                                          )
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "cellPhone" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.cellPhone"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("cellPhone"),
                                          expression: "errors.has('cellPhone')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("cellPhone"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "form-group",
                                attrs: { id: "selectWrapper" },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    attrs: {
                                      label: _vm.$t(
                                        "createApp.appInfo.country"
                                      ),
                                      name: "country",
                                      readonly: true,
                                      autocomplete: "off",
                                    },
                                    domProps: {
                                      value: _vm.queryCountry(
                                        _vm.appForm.country
                                      ),
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "cellPhone" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.appInfo.country"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                              ]
                            ),
                            _c("div", { staticClass: "form-group" }, [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.appForm.createTime,
                                      expression: "appForm.createTime",
                                    },
                                  ],
                                  attrs: {
                                    id: "date-picker-time",
                                    autocomplete: "off",
                                    readonly: true,
                                  },
                                  domProps: { value: _vm.appForm.createTime },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.appForm,
                                        "createTime",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "date-picker-time" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.appInfo.createTime"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md10" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                attrs: {
                                  id: "appNameShortInput",
                                  name: "appNameShort",
                                  readonly: true,
                                  autocomplete: "off",
                                },
                                domProps: { value: _vm.appForm.appNameShort },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "appNameShort" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.appNameShort"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                attrs: {
                                  id: "managerNameInput",
                                  name: "managerName",
                                  readonly: true,
                                  autocomplete: "off",
                                },
                                domProps: { value: _vm.appForm.managerName },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "managerName" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.managerName"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                attrs: {
                                  id: "cellPhone",
                                  name: "cellPhone",
                                  readonly: true,
                                  autocomplete: "off",
                                  maxlength: "17",
                                },
                                domProps: { value: _vm.appForm.cellPhone },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "cellPhone" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.cellPhone"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "form-group",
                              attrs: { id: "selectWrapper" },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  attrs: {
                                    label: _vm.$t("t.country") + "：",
                                    name: "country",
                                    readonly: true,
                                    autocomplete: "off",
                                  },
                                  domProps: {
                                    value: _vm.queryCountry(
                                      _vm.appForm.country
                                    ),
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "cellPhone" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.appInfo.country"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]
                          ),
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.appForm.createTime,
                                    expression: "appForm.createTime",
                                  },
                                ],
                                attrs: {
                                  id: "date-picker-time",
                                  autocomplete: "off",
                                  readonly: true,
                                },
                                domProps: { value: _vm.appForm.createTime },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.appForm,
                                      "createTime",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "date-picker-time" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.appInfo.createTime"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                        ]),
                      ]),
                ]),
                _vm.showFileUploadFg
                  ? _c(
                      "div",
                      {
                        staticClass: "va-row",
                        style: {
                          marginTop: _vm.curMode === "view" ? "-3rem" : "1rem",
                        },
                      },
                      [
                        _c("div", { staticClass: "flex xs12 md12" }, [
                          _c("form", { attrs: { name: "fileUpload" } }, [
                            _c("div", { staticClass: "form-group" }, [
                              _vm.curMode === "view" && _vm.previewImage
                                ? _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "uploadAppLogo" },
                                    },
                                    [_vm._v("App Logo：")]
                                  )
                                : _vm._e(),
                              _vm.curMode === "config"
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: { "padding-right": "40px" },
                                      attrs: { id: "appLogoWrapper" },
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "control-label",
                                          attrs: { for: "uploadAppLogo" },
                                        },
                                        [_vm._v("App Logo：")]
                                      ),
                                      _c("vuestic-file-upload", {
                                        ref: "fieldInput",
                                        attrs: {
                                          id: "uploadAppLogo",
                                          type: "single",
                                          "file-types":
                                            ".png, .jpg, .jpeg, .gif",
                                          isShowDelete: true,
                                        },
                                        on: { input: _vm.uploadFile },
                                        model: {
                                          value: _vm.appLogo,
                                          callback: function ($$v) {
                                            _vm.appLogo = $$v
                                          },
                                          expression: "appLogo",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.previewImage
                                ? _c(
                                    "div",
                                    { staticClass: "file-upload-item" },
                                    [
                                      _c("img", {
                                        staticClass: "file-upload-item-image",
                                        attrs: {
                                          src: _vm.previewImage,
                                          alt: "App Logo",
                                        },
                                      }),
                                    ]
                                  )
                                : _vm._e(),
                            ]),
                          ]),
                          _c("span", { staticClass: "pic-desc" }, [
                            _c("span", {
                              staticClass: "entypo entypo-info-circled",
                              attrs: { "aria-hidden": "true" },
                            }),
                            _vm._v(
                              "The recommended size of the uploaded image: width 60~90 pixels, height 35~50 pixels."
                            ),
                          ]),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "flex md12 xs12",
            staticStyle: { "padding-top": "0" },
          },
          [
            _c(
              "vuestic-widget",
              {
                attrs: {
                  headerText: _vm._f("translate")("forms.inputs.report2Send"),
                  id: "fileShowWrapper",
                },
              },
              [
                _c("div", { staticClass: "va-row" }, [
                  _c("div", { staticClass: "flex xs12 md12" }, [
                    _c("fieldset", [
                      _vm.curMode === "config"
                        ? _c(
                            "div",
                            {
                              staticClass: "form-group with-icon-right",
                              class: {
                                "has-error": _vm.initmailsVaild,
                                valid: _vm.isSuccessfulEmailValid,
                              },
                            },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.appForm.userEmails,
                                      expression: "appForm.userEmails",
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'",
                                    },
                                  ],
                                  staticClass: "emailsTextArea",
                                  staticStyle: { overflow: "auto" },
                                  style: _vm.marginTop,
                                  attrs: {
                                    id: "userEmails",
                                    name: "userEmails",
                                    autocomplete: "off",
                                    maxlength: "255",
                                    rows: "1",
                                    placeholder: "email;email",
                                    required: "",
                                  },
                                  domProps: { value: _vm.appForm.userEmails },
                                  on: {
                                    input: [
                                      function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "userEmails",
                                          $event.target.value
                                        )
                                      },
                                      function ($event) {
                                        return _vm.resizeEmailLabel(
                                          $event,
                                          !_vm.isSuccessfulEmailValid
                                        )
                                      },
                                    ],
                                    blur: function ($event) {
                                      return _vm.focusEmailLabel(
                                        $event,
                                        !_vm.isSuccessfulEmailValid
                                      )
                                    },
                                  },
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                }),
                                _c("i", {
                                  staticClass:
                                    "fa fa-check valid-icon icon-right input-icon",
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "userEmails" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "forms.inputs.emailValidatedSuccess"
                                        )
                                      ) + ":"
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                                _c(
                                  "small",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.initmailsVaild,
                                        expression: "initmailsVaild",
                                      },
                                    ],
                                    staticClass: "help text-danger",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.mailsInfoMsg ||
                                          _vm.errors.first("userEmails")
                                      )
                                    ),
                                  ]
                                ),
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("t.youCanAddUp"))),
                                ]),
                              ]),
                            ]
                          )
                        : _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.appForm.userEmails,
                                    expression: "appForm.userEmails",
                                  },
                                ],
                                staticStyle: { overflow: "auto" },
                                style: _vm.marginTop,
                                attrs: {
                                  id: "userEmails",
                                  name: "userEmails",
                                  autocomplete: "off",
                                  maxlength: "255",
                                  rows: "1",
                                  readonly: true,
                                  placeholder: "",
                                },
                                domProps: { value: _vm.appForm.userEmails },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.appForm,
                                      "userEmails",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "userEmails" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "forms.inputs.emailValidatedSuccess"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                    ]),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "flex md12 xs12",
            staticStyle: { "padding-top": "0" },
          },
          [
            _c(
              "vuestic-widget",
              {
                attrs: {
                  headerText: _vm._f("translate")("forms.inputs.configs"),
                },
              },
              [
                _c("div", { staticClass: "va-row" }, [
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md10" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("midInput"),
                                  valid: _vm.isFormFieldValid("midInput"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.tid,
                                        expression: "appForm.tid",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "midInput",
                                      name: "midInput",
                                      "data-vv-as": "Name",
                                      autocomplete: "off",
                                      required: "",
                                      readonly: true,
                                    },
                                    domProps: { value: _vm.appForm.tid },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "tid",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "midInput" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.configs.mid"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("midInput"),
                                          expression: "errors.has('midInput')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.errors.first("midInput"))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md10" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c("div", { staticClass: "input-group" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.appForm.tid,
                                      expression: "appForm.tid",
                                    },
                                  ],
                                  attrs: {
                                    id: "midInput",
                                    name: "midInput",
                                    readonly: true,
                                    autocomplete: "off",
                                  },
                                  domProps: { value: _vm.appForm.tid },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        _vm.appForm,
                                        "tid",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "midInput" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.configs.mid"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                            ]),
                          ]),
                        ]
                      ),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md10" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-group with-icon-right",
                                class: {
                                  "has-error": _vm.errors.has("appId"),
                                  valid: _vm.isFormFieldValid("appId"),
                                },
                              },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.appForm.appId,
                                        expression: "appForm.appId",
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'",
                                      },
                                    ],
                                    attrs: {
                                      id: "appId",
                                      name: "appId",
                                      "data-vv-as": "Name",
                                      autocomplete: "off",
                                      required: "",
                                      readonly: true,
                                    },
                                    domProps: { value: _vm.appForm.appId },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.appForm,
                                          "appId",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-triangle error-icon icon-right input-icon",
                                  }),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-check valid-icon icon-right input-icon",
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "appId" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.configs.appId"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                  _c(
                                    "small",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.errors.has("appId"),
                                          expression: "errors.has('appId')",
                                        },
                                      ],
                                      staticClass: "help text-danger",
                                    },
                                    [_vm._v(_vm._s(_vm.errors.first("appId")))]
                                  ),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md10" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "input-group" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.appForm.appId,
                                    expression: "appForm.appId",
                                  },
                                ],
                                attrs: {
                                  id: "appId",
                                  name: "appId",
                                  "data-vv-as": "Name",
                                  readonly: true,
                                  autocomplete: "off",
                                },
                                domProps: { value: _vm.appForm.appId },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.appForm,
                                      "appId",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "appId" },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "createApp.configs.appId"
                                      )
                                    ) + "："
                                  ),
                                ]
                              ),
                              _c("i", { staticClass: "bar" }),
                            ]),
                          ]),
                        ]),
                      ]),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md12",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group eye-password-wrap" },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("textarea", {
                                    staticStyle: { overflow: "auto" },
                                    style: _vm.marginTop,
                                    attrs: {
                                      id: "securityKey",
                                      name: "securityKey",
                                      autocomplete: "off",
                                      maxlength: "255",
                                      rows: "3",
                                      readonly: true,
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.isSecurityKeyOpen
                                        ? _vm.appForm.securityKey
                                        : "******",
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "securityKey" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.configs.securityKey"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        staticStyle: {
                                          "flex-direction": "column",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-micro btn-primary btn-with-icon mb-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getLastMerchantKey(
                                                  "MerchantPrivateKey",
                                                  "isSecurityKeyOpen"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-with-icon-content",
                                                attrs: {
                                                  id: "btn-ico-wrapper",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "ico ico-md-entypo entypo-cw",
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "centerFont" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("translate")(
                                                          "buttons.update"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.isSecurityKeyOpen
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-info btn-micro btn-with-icon mr-2",
                                                attrs: {
                                                  disabled: _vm.isCopySuccess,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.securityKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.$t("t.copy")) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "eye-password",
                                        staticStyle: { left: "100px" },
                                      },
                                      [
                                        !_vm.isSecurityKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.closeEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isSecurityKeyOpen",
                                                    true,
                                                    "securityKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isSecurityKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.openEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isSecurityKeyOpen",
                                                    false,
                                                    "securityKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "flex xs12 md6",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group eye-password-wrap" },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("textarea", {
                                    staticStyle: { overflow: "auto" },
                                    style: _vm.marginTop,
                                    attrs: {
                                      id: "securityKey",
                                      name: "securityKey",
                                      autocomplete: "off",
                                      maxlength: "255",
                                      rows: "3",
                                      readonly: true,
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.isSecurityKeyOpen
                                        ? _vm.appForm.securityKey
                                        : "******",
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "securityKey" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.configs.securityKey"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "eye-password d-flex",
                                        staticStyle: { left: "100px" },
                                      },
                                      [
                                        !_vm.isSecurityKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.closeEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isSecurityKeyOpen",
                                                    true,
                                                    "securityKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isSecurityKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.openEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isSecurityKeyOpen",
                                                    false,
                                                    "securityKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isSecurityKeyOpen
                                          ? _c(
                                              "el-tooltip",
                                              {
                                                staticClass: "item",
                                                attrs: {
                                                  effect: "light",
                                                  content: "Copy",
                                                  placement: "top",
                                                },
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    src: _vm.copyIcon,
                                                    alt: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyText(
                                                        _vm.appForm.securityKey
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md12",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group eye-password-wrap" },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("textarea", {
                                    staticStyle: { overflow: "auto" },
                                    style: _vm.marginTop,
                                    attrs: {
                                      id: "publicKey",
                                      name: "publicKey",
                                      autocomplete: "off",
                                      maxlength: "255",
                                      rows: "3",
                                      readonly: true,
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.isPublicKeyOpen
                                        ? _vm.appForm.publicKey
                                        : "******",
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "publicKey" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("translate")(
                                            "createApp.configs.publicKey"
                                          )
                                        ) + "："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        staticStyle: {
                                          "flex-direction": "column",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-micro btn-primary btn-with-icon mb-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getLastMerchantKey(
                                                  "MerchantPublicKey",
                                                  "isPublicKeyOpen"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-with-icon-content",
                                                attrs: {
                                                  id: "btn-ico-wrapper",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "ico ico-md-entypo entypo-cw",
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "centerFont" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("translate")(
                                                          "buttons.update"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.isPublicKeyOpen
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-info btn-micro btn-with-icon mr-2",
                                                attrs: {
                                                  disabled: _vm.isCopySuccess,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.publicKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.$t("t.copy")) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "eye-password",
                                        staticStyle: { left: "95px" },
                                      },
                                      [
                                        !_vm.isPublicKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.closeEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isPublicKeyOpen",
                                                    true,
                                                    "publicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isPublicKeyOpen
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.openEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isPublicKeyOpen",
                                                    false,
                                                    "publicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group eye-password-wrap" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("textarea", {
                                  staticStyle: { overflow: "auto" },
                                  style: _vm.marginTop,
                                  attrs: {
                                    id: "publicKey",
                                    name: "publicKey",
                                    autocomplete: "off",
                                    maxlength: "255",
                                    rows: "3",
                                    readonly: true,
                                    placeholder: "",
                                  },
                                  domProps: {
                                    value: _vm.isPublicKeyOpen
                                      ? _vm.appForm.publicKey
                                      : "******",
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "publicKey" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "createApp.configs.publicKey"
                                        )
                                      ) + "："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                              _vm.isAdmin
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "eye-password d-flex",
                                      staticStyle: { left: "95px" },
                                    },
                                    [
                                      !_vm.isPublicKeyOpen
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.closeEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isPublicKeyOpen",
                                                  true,
                                                  "publicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isPublicKeyOpen
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.openEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isPublicKeyOpen",
                                                  false,
                                                  "publicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isPublicKeyOpen
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "light",
                                                content: "Copy",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  src: _vm.copyIcon,
                                                  alt: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.publicKey
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md12",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group eye-password-wrap" },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("textarea", {
                                    staticStyle: { overflow: "auto" },
                                    style: _vm.marginTop,
                                    attrs: {
                                      id: "publicKey",
                                      name: "publicKey",
                                      autocomplete: "off",
                                      maxlength: "255",
                                      rows: "3",
                                      readonly: true,
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.isMerchantRsaPublicKey
                                        ? _vm.appForm.mRsaPublicKey
                                        : "******",
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "publicKey" },
                                    },
                                    [_vm._v("Merchant RSA Public Key：")]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        staticStyle: {
                                          "flex-direction": "column",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-micro btn-primary btn-with-icon mb-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getLastMerchantKey(
                                                  "MerchantRsaPublicKey",
                                                  "isMerchantRsaPublicKey"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-with-icon-content",
                                                attrs: {
                                                  id: "btn-ico-wrapper",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "ico ico-md-entypo entypo-cw",
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "centerFont" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("translate")(
                                                          "buttons.update"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.isMerchantRsaPublicKey
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-info btn-micro btn-with-icon mr-2",
                                                attrs: {
                                                  disabled: _vm.isCopySuccess,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.mRsaPublicKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.$t("t.copy")) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "eye-password",
                                        staticStyle: { left: "180px" },
                                      },
                                      [
                                        !_vm.isMerchantRsaPublicKey
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.closeEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isMerchantRsaPublicKey",
                                                    true,
                                                    "mRsaPublicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isMerchantRsaPublicKey
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.openEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isMerchantRsaPublicKey",
                                                    false,
                                                    "mRsaPublicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group eye-password-wrap" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("textarea", {
                                  staticStyle: { overflow: "auto" },
                                  style: _vm.marginTop,
                                  attrs: {
                                    id: "publicKey",
                                    name: "publicKey",
                                    autocomplete: "off",
                                    maxlength: "255",
                                    rows: "3",
                                    readonly: true,
                                    placeholder: "",
                                  },
                                  domProps: {
                                    value: _vm.isMerchantRsaPublicKey
                                      ? _vm.appForm.mRsaPublicKey
                                      : "******",
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "publicKey" },
                                  },
                                  [_vm._v("Merchant RSA Public Key：")]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                              _vm.isAdmin
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "eye-password d-flex",
                                      staticStyle: { left: "180px" },
                                    },
                                    [
                                      !_vm.isMerchantRsaPublicKey
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.closeEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isMerchantRsaPublicKey",
                                                  true,
                                                  "mRsaPublicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isMerchantRsaPublicKey
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.openEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isMerchantRsaPublicKey",
                                                  false,
                                                  "mRsaPublicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isMerchantRsaPublicKey
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "light",
                                                content: "Copy",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  src: _vm.copyIcon,
                                                  alt: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.mRsaPublicKey
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                  _vm.curMode === "config"
                    ? _c(
                        "div",
                        {
                          staticClass: "flex xs12 md12",
                          staticStyle: { "max-height": "266px" },
                        },
                        [
                          _c("fieldset", { staticClass: "flex xs12 md12" }, [
                            _c(
                              "div",
                              { staticClass: "form-group eye-password-wrap" },
                              [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("textarea", {
                                    staticStyle: { overflow: "auto" },
                                    style: _vm.marginTop,
                                    attrs: {
                                      id: "publicKey",
                                      name: "publicKey",
                                      autocomplete: "off",
                                      maxlength: "255",
                                      rows: "3",
                                      readonly: true,
                                      placeholder: "",
                                    },
                                    domProps: {
                                      value: _vm.isPagsmileRsaPublicKey
                                        ? _vm.appForm.psPublicKey
                                        : "******",
                                    },
                                  }),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "control-label",
                                      attrs: { for: "publicKey" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.VUE_APP_NAME) +
                                          " RSA Public Key："
                                      ),
                                    ]
                                  ),
                                  _c("i", { staticClass: "bar" }),
                                ]),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "d-flex",
                                        staticStyle: {
                                          "flex-direction": "column",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn btn-micro btn-primary btn-with-icon mb-2",
                                            on: {
                                              click: function ($event) {
                                                return _vm.getLastMerchantKey(
                                                  "PagsmileRsaPublicKey",
                                                  "isPagsmileRsaPublicKey"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-with-icon-content",
                                                attrs: {
                                                  id: "btn-ico-wrapper",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "ico ico-md-entypo entypo-cw",
                                                }),
                                                _c(
                                                  "div",
                                                  { staticClass: "centerFont" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f("translate")(
                                                          "buttons.update"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.isPagsmileRsaPublicKey
                                          ? _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-info btn-micro btn-with-icon mr-2",
                                                attrs: {
                                                  disabled: _vm.isCopySuccess,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.psPublicKey
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(_vm.$t("t.copy")) +
                                                    "\n                    "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.isAdmin
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "eye-password",
                                        staticStyle: { left: "180px" },
                                      },
                                      [
                                        !_vm.isPagsmileRsaPublicKey
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.closeEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isPagsmileRsaPublicKey",
                                                    true,
                                                    "psPublicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.isPagsmileRsaPublicKey
                                          ? _c("img", {
                                              attrs: {
                                                src: _vm.openEye,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showEyePassword(
                                                    "isPagsmileRsaPublicKey",
                                                    false,
                                                    "psPublicKey"
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      )
                    : _c("div", { staticClass: "flex xs12 md6" }, [
                        _c("fieldset", { staticClass: "flex xs12 md12" }, [
                          _c(
                            "div",
                            { staticClass: "form-group eye-password-wrap" },
                            [
                              _c("div", { staticClass: "input-group" }, [
                                _c("textarea", {
                                  staticStyle: { overflow: "auto" },
                                  style: _vm.marginTop,
                                  attrs: {
                                    id: "publicKey",
                                    name: "publicKey",
                                    autocomplete: "off",
                                    maxlength: "255",
                                    rows: "3",
                                    readonly: true,
                                    placeholder: "",
                                  },
                                  domProps: {
                                    value: _vm.isPagsmileRsaPublicKey
                                      ? _vm.appForm.psPublicKey
                                      : "******",
                                  },
                                }),
                                _c(
                                  "label",
                                  {
                                    staticClass: "control-label",
                                    attrs: { for: "publicKey" },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.VUE_APP_NAME) +
                                        " RSA Public Key："
                                    ),
                                  ]
                                ),
                                _c("i", { staticClass: "bar" }),
                              ]),
                              _vm.isAdmin
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "eye-password d-flex",
                                      staticStyle: { left: "180px" },
                                    },
                                    [
                                      !_vm.isPagsmileRsaPublicKey
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.closeEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isPagsmileRsaPublicKey",
                                                  true,
                                                  "psPublicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isPagsmileRsaPublicKey
                                        ? _c("img", {
                                            attrs: {
                                              src: _vm.openEye,
                                              alt: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.showEyePassword(
                                                  "isPagsmileRsaPublicKey",
                                                  false,
                                                  "psPublicKey"
                                                )
                                              },
                                            },
                                          })
                                        : _vm._e(),
                                      _vm.isPagsmileRsaPublicKey
                                        ? _c(
                                            "el-tooltip",
                                            {
                                              staticClass: "item",
                                              attrs: {
                                                effect: "light",
                                                content: "Copy",
                                                placement: "top",
                                              },
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "ml-1",
                                                attrs: {
                                                  src: _vm.copyIcon,
                                                  alt: "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.copyText(
                                                      _vm.appForm.psPublicKey
                                                    )
                                                  },
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]),
                ]),
                _vm.curMode === "config"
                  ? _c("div", { staticClass: "va-row" }, [
                      _c("div", { staticClass: "flex xs12 md12" }, [
                        _c("div", { staticClass: "section-comfirm" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm comfirm-ok",
                              attrs: { id: "confirmCreateApp" },
                              on: { click: _vm.appdata },
                            },
                            [_vm._v(_vm._s(_vm.$t("basic.button.confirm")))]
                          ),
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-secondary btn-sm comfirm-cel",
                              attrs: { id: "cancelCreateApp" },
                              on: { click: _vm.backBtnPre },
                            },
                            [_vm._v(_vm._s(_vm.$t("basic.button.cancel")))]
                          ),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm.isToastContent
        ? _c("div", { staticClass: "flex xs12 md6 flex-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "toasted-container sample-toasted-container shrink",
              },
              [
                _c(
                  "div",
                  { staticClass: "toasted vuestic-toast none default" },
                  [
                    _vm.toastIcon
                      ? _c("i", { staticClass: "fa", class: _vm.toastIcon })
                      : _vm._e(),
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.toastText) + "\n\t\t\t\t"
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _c(
        "button",
        {
          staticClass: "btn btn-primary focus btn-sm",
          attrs: { id: "appInfoBackBtn" },
          on: { click: _vm.goBack },
        },
        [_vm._v(_vm._s(_vm.$t("back")))]
      ),
      _c(
        "vuestic-modal",
        {
          ref: "passwordModal",
          staticClass: "password-key-modal",
          staticStyle: { height: "100%", width: "60vw" },
          attrs: {
            "show.sync": "true",
            okText: _vm._f("translate")("modal.confirm2"),
            okClass: "btn btn-primary btn-micro",
            cancelClass: "btn btn-secondary btn-micro",
            cancelText: _vm._f("translate")("modal.cancel2"),
            alignModal: "",
          },
        },
        [
          _c("div", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("auth.password"))),
          ]),
          _c("div", [
            _c("form", { attrs: { onsubmit: "return false" } }, [
              _c("div", { staticClass: "va-row" }, [
                _c("div", { staticClass: "flex xs12 md12" }, [
                  _c("fieldset", [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-group with-icon-right eye-password-modal",
                        class: {
                          "has-error": _vm.errors.has("validPassword"),
                          valid: _vm.isFormFieldValid("validPassword"),
                        },
                      },
                      [
                        _c("div", { staticClass: "input-group" }, [
                          (_vm.isPasswordOpen ? "text" : "password") ===
                          "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.validatePasswordBean.password,
                                    expression: "validatePasswordBean.password",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "validPassword",
                                  name: "validPassword",
                                  "data-vv-as": "Password",
                                  autocomplete: "off",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.validatePasswordBean.password
                                  )
                                    ? _vm._i(
                                        _vm.validatePasswordBean.password,
                                        null
                                      ) > -1
                                    : _vm.validatePasswordBean.password,
                                },
                                on: {
                                  change: function ($event) {
                                    var $$a = _vm.validatePasswordBean.password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.validatePasswordBean,
                                            "password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.validatePasswordBean,
                                            "password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(
                                        _vm.validatePasswordBean,
                                        "password",
                                        $$c
                                      )
                                    }
                                  },
                                },
                              })
                            : (_vm.isPasswordOpen ? "text" : "password") ===
                              "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.validatePasswordBean.password,
                                    expression: "validatePasswordBean.password",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "validPassword",
                                  name: "validPassword",
                                  "data-vv-as": "Password",
                                  autocomplete: "off",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(
                                    _vm.validatePasswordBean.password,
                                    null
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.validatePasswordBean,
                                      "password",
                                      null
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.validatePasswordBean.password,
                                    expression: "validatePasswordBean.password",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                attrs: {
                                  id: "validPassword",
                                  name: "validPassword",
                                  "data-vv-as": "Password",
                                  autocomplete: "off",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                  type: _vm.isPasswordOpen
                                    ? "text"
                                    : "password",
                                },
                                domProps: {
                                  value: _vm.validatePasswordBean.password,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.validatePasswordBean,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _c("i", {
                            staticClass:
                              "fa fa-exclamation-triangle error-icon icon-right input-icon",
                          }),
                          _c("i", {
                            staticClass:
                              "fa fa-check valid-icon icon-right input-icon",
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "control-label",
                              attrs: { for: "validPassword" },
                            },
                            [_vm._v("Password：")]
                          ),
                          _c("i", { staticClass: "bar" }),
                          _vm.isAdmin
                            ? _c("div", { staticClass: "eye-password" }, [
                                !_vm.isPasswordOpen
                                  ? _c("img", {
                                      attrs: { src: _vm.closeEye, alt: "" },
                                      on: {
                                        click: () => {
                                          _vm.isPasswordOpen = true
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.isPasswordOpen
                                  ? _c("img", {
                                      attrs: { src: _vm.openEye, alt: "" },
                                      on: {
                                        click: () => {
                                          _vm.isPasswordOpen = false
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                          _c(
                            "small",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("validPassword"),
                                  expression: "errors.has('validPassword')",
                                },
                              ],
                              staticClass: "help text-danger",
                            },
                            [_vm._v(_vm._s(_vm.errors.first("validPassword")))]
                          ),
                        ]),
                      ]
                    ),
                    _vm.isShowMerchantPublicKeyTextarea
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "form-group with-icon-right eye-password-modal",
                            class: {
                              "has-error": _vm.errors.has(
                                "validateMerchantPublicKey"
                              ),
                              valid: _vm.isFormFieldValid(
                                "validateMerchantPublicKey"
                              ),
                            },
                          },
                          [
                            _c("div", { staticClass: "input-group" }, [
                              _c("textarea", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.validatePasswordBean
                                        .merchantPublicKeyTextarea,
                                    expression:
                                      "validatePasswordBean.merchantPublicKeyTextarea",
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'",
                                  },
                                ],
                                staticStyle: { overflow: "auto" },
                                style: _vm.marginTop,
                                attrs: {
                                  id: "validateMerchantPublicKey",
                                  name: "validateMerchantPublicKey",
                                  "data-vv-as": "Merchant Public Key",
                                  maxlength: "2048",
                                  rows: "3",
                                  autocomplete: "off",
                                  required: "",
                                  onkeyup: "value=value.replace(/\\s/g,'')",
                                  onkeydown: "value=value.replace(/\\s/g,'')",
                                },
                                domProps: {
                                  value:
                                    _vm.validatePasswordBean
                                      .merchantPublicKeyTextarea,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.validatePasswordBean,
                                      "merchantPublicKeyTextarea",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-exclamation-triangle error-icon icon-right input-icon",
                              }),
                              _c("i", {
                                staticClass:
                                  "fa fa-check valid-icon icon-right input-icon",
                              }),
                              _c(
                                "label",
                                {
                                  staticClass: "control-label",
                                  attrs: { for: "validateMerchantPublicKey" },
                                },
                                [_vm._v("Merchant Public Key：")]
                              ),
                              _c("i", { staticClass: "bar" }),
                              _c(
                                "small",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.errors.has(
                                        "validateMerchantPublicKey"
                                      ),
                                      expression:
                                        "errors.has('validateMerchantPublicKey')",
                                    },
                                  ],
                                  staticClass: "help text-danger",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.errors.first(
                                        "validateMerchantPublicKey"
                                      )
                                    )
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }